 
<div >

    <div style="z-index: 10;">
        
        <form [formGroup]="userForm" (ngSubmit)="SubmitUser()">
            <div class="card-body border-external">
                <div style="height:90px; color:gray;padding:13px">
                      <span>{{'ForgotPasswordLabel_001' | translate}}</span> 
                    </div>
                <div class="form-group ">
                    <!-- <span class="col-md-4">{{'LOGIN_OD0002' | translate}}</span> -->
                    <span class="col-md-4">{{'LoginUserLabel_001'| translate}}</span> 
                    <span class="col-md-4">
                        <input style="background-color: #dcdcdc85;" type="text"
                            formControlName="userIdname" placeholder="#" [(ngModel)]="userIdname"
                            (input)="onInputChange(userIdname)" 
                             ></span>
                </div>

               <div *ngIf="userMessage" style="height: 53px; padding:20px;">
                   <span>
                     <b>  {{'ResetPasswordClickLabel_001' | translate}} </b>
                   </span>
               </div>
               <div *ngIf="userWarningMessage" style="height: 60px; padding:20px;">
                <span>
                  <b>  {{'ResetWarningMessage_001' | translate}} </b>
                </span>
            </div>
                
                <!-- <div class="d-flex mt-4" style="justify-content: center;">
                     <img class="mr-3" src="../../../../../assets/Logos/error-message.svg"> -- no need 
                    <div style="color:red; font-size: 18px; font-weight: bold;">{{errorMsg | translate}}</div>
                </div> -->
            </div>
            <div   class="footer-class border-external"  >
                
                <button class="btn btn-orange border-external" [disabled]="!showResetButton || !disableOnSubmit">
                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32"
                        viewBox="0 0 172 172" style="height: 25px; fill:#000000;">
                        <g transform="">
                            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                style="mix-blend-mode: normal">
                                <path d="M0,172v-172h172v172z" fill="#e67e22"></path>
                                <g id="original-icon" fill="#ffffff">
                                    <path
                                        d="M53.75,16.125v53.75h10.75v-43h75.25v118.25h-75.25v-43h-10.75v53.75h96.75v-139.75zM87.84766,60.63672l-7.72656,7.72656l12.26172,12.26172h-65.50781v10.75h65.50781l-12.26172,12.26172l7.72656,7.72656l21.5,-21.5l3.69531,-3.86328l-3.69531,-3.86328z">
                                    </path>
                                </g>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                            </g>
                        </g>
                    </svg>
                    {{ 'ResetForgotPasswordLabel_001' | translate}}
                    <!-- {{'LOGIN_OD0004' | translate}} -->
                </button>
            </div>
        </form>
    </div>
</div>
             
             
           